import i18next from 'i18next';

const REQUEST_ERROR_SUMMARY_FALLBACK = 'Request could not be completed';
const REQUEST_ERROR_DETAIL_FALLBACK =
  'Please try again. If the issue continues, contact support. Reference code: {{referenceCode}}.';

export const getRequestErrorSummary = (): string =>
  i18next.t('common.request_error.summary', {
    defaultValue: REQUEST_ERROR_SUMMARY_FALLBACK,
  }) || REQUEST_ERROR_SUMMARY_FALLBACK;

export const getRequestErrorDetail = (referenceCode: string | number): string =>
  i18next.t('common.request_error.detail', {
    defaultValue: REQUEST_ERROR_DETAIL_FALLBACK,
    referenceCode,
  }) ||
  `Please try again. If the issue continues, contact support. Reference code: ${referenceCode}.`;
